
<div class="modal-dialog confirm-dialog">
  <div class="modal-content" style="min-width:600px;">
    <div class="modal-header">
      <h4 class="modal-title">Error Detail</h4>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <p>Unable to upload assets due to data not mapped correctly</p>
      <div *ngFor="let item of detail" style="font-size: 14px; color: #555; white-space: pre-line;">
        <error [error]="item" [showPossibleResolution]="false"></error>
        <div><a class="btn btn-danger" *ngIf="isMultipleErrorCode" href="javascript:void(0)" (click)="openDialog(item)">Possible Resolution</a></div><br>
      </div>
      <div><a class="btn btn-danger" *ngIf="!isMultipleErrorCode" href="javascript:void(0)" (click)="openDialog(possibleResolutionDetail[0])">Possible Resolution</a></div>
    </div>
  </div>
</div>